import { duration, durationCss, easing, keyframes, springConfig } from '@digiwedge/ui-tokens';
export { duration, durationCss, easing, keyframes, springConfig };
export const motionClassNames = {
    fadeIn: 'animate-fade-in',
    fadeOut: 'animate-fade-out',
    scaleIn: 'animate-scale-in',
    slideIn: 'animate-slide-in',
    slideOut: 'animate-slide-out',
};
export const transitionClassNames = {
    default: 'transition-all duration-[var(--animation-duration)] ease-out',
    fast: 'transition-all duration-[var(--animation-duration-fast)] ease-out',
    medium: 'transition-all duration-[var(--animation-duration-medium)] ease-out',
    slow: 'transition-all duration-[var(--animation-duration-slow)] ease-out',
};
export const dialogTransition = {
    overlay: {
        enter: 'ease-out duration-[var(--animation-duration-medium)]',
        enterFrom: 'opacity-0',
        enterTo: 'opacity-100',
        leave: 'ease-in duration-[var(--animation-duration)]',
        leaveFrom: 'opacity-100',
        leaveTo: 'opacity-0',
    },
    panel: {
        enter: 'ease-out duration-[var(--animation-duration-medium)]',
        enterFrom: 'opacity-0 scale-95',
        enterTo: 'opacity-100 scale-100',
        leave: 'ease-in duration-[var(--animation-duration)]',
        leaveFrom: 'opacity-100 scale-100',
        leaveTo: 'opacity-0 scale-95',
    },
};
export const dialogTransitionSlow = {
    overlay: {
        enter: 'ease-out duration-[var(--animation-duration-slow)]',
        enterFrom: 'opacity-0',
        enterTo: 'opacity-100',
        leave: 'ease-in duration-[var(--animation-duration-medium)]',
        leaveFrom: 'opacity-100',
        leaveTo: 'opacity-0',
    },
    panel: {
        enter: 'ease-out duration-[var(--animation-duration-slow)]',
        enterFrom: 'opacity-0 scale-95',
        enterTo: 'opacity-100 scale-100',
        leave: 'ease-in duration-[var(--animation-duration-medium)]',
        leaveFrom: 'opacity-100 scale-100',
        leaveTo: 'opacity-0 scale-95',
    },
};
//# sourceMappingURL=motion.js.map